import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { TwinfieldService } from "../../services/twinfield.service";
import { twinfieldOAuthCallbackComponent } from './twinfield.component';
import { twinfieldState } from "./twinfield.states";

const twinfieldAppModule: aboTheme.INgModule = {
    components: {
        twinfieldOAuthCallbackComponent
    },
    services: {
        TwinfieldService,
    },
    states: [twinfieldState],
};

loadNg1Module(ngmodule, twinfieldAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/twinfield/index.ts